import Form from '@rjsf/mui';
import Footer from '../landing/Footer';
import Header from '../landing/Header';
import { Button, Typography } from '@mui/material';
import validator from '@rjsf/validator-ajv8';
import { useSearch } from 'react-location';
import { useGetForm } from '../../modules/datastores/useGetForm';
import { SelectWidget, TextareaWidget } from '../feedback/FeedbackForm';
import type { RegistryWidgetsType } from '@rjsf/utils';
import { useSubmitVisitorFeedback } from '../../modules/datastores/useGetMessages';
import { uiStore } from '../../modules/datastores/useUiStore';
import { useRef } from 'react';
import pageStyles from './smsform.module.scss';
import useGetSurvivorsConversation from '../../modules/datastores/useGetSurvivorsConversation';

const SmsFeedbackForm = () => {
  const query = useSearch();
  const task_sid = query['task_sid'];
  const form_id = query['form_id'] as string;
  const { data: formsQuery, isSuccess } = useGetForm(form_id);
  const { mutateAsync: mutateVisitorFormSubmission } = useSubmitVisitorFeedback();
  const customWidgets: RegistryWidgetsType = {
    TextareaWidget: TextareaWidget as any,
    SelectWidget: SelectWidget as any,
  };
  const isApiCalled = useRef(false);
  const conv = useGetSurvivorsConversation();

  const submitFeedback = ({ formData }: any) => {
    isApiCalled.current = true;
    const updated_feedback = {
      form_id,
      identity: task_sid,
      submission: {
        task_sid,
        formData,
      },
      complete_request: true,
      display_name: task_sid,
    };
    mutateVisitorFormSubmission(updated_feedback, {
      onSuccess: () => {
        uiStore.setSuccessMessage('Thank you for your feedback, Its Safe to Close Your Browser Tab!');
      },
      onError(error: any) {
        uiStore.setErrorMessage(error?.errors?.toString());
      },
    });
  };

  const onError = (errors: unknown) => {
    return errors;
  };
  return (
    <>
      <Header />
      {isSuccess && form_id !== '' && formsQuery?.fields && formsQuery.field_specs && (
        <div className={pageStyles.smsform}>
          <div className={pageStyles.smsform__box}>
            <Typography variant="h2" className="text-black font-bold text-lg">
              {`${conv.smsFormData.channelType.toUpperCase()} Feedback Form`}
            </Typography>
            {conv.smsFormData.channelType.toLowerCase() === 'whatsapp' && (
              <Typography variant="h2" className="text-black font-bold text-lg">
                Formulario de comentarios de Whatsapp
              </Typography>
            )}
            <Form
              validator={validator}
              schema={formsQuery?.fields}
              widgets={customWidgets as any}
              showErrorList={false}
              onError={onError}
              noHtml5Validate
              uiSchema={formsQuery?.field_specs}
              onSubmit={submitFeedback}
              className="rjsf w-feedback-form"
            >
              <Button disabled={isApiCalled.current} className="button-primary mr-2" type="submit">
                Submit Feedback
              </Button>
            </Form>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default SmsFeedbackForm;
